/* R32 Smart Fill. Measures only existing product-page whitespace; never changes cart, price or membership state. */
(() => {
  'use strict';
  if (window.__mmR32SmartFill) return;
  window.__mmR32SmartFill = true;
  const desktop = matchMedia('(min-width:990px)');
  const money = new Intl.NumberFormat(document.documentElement.lang?.startsWith('es') ? 'es-US' : 'en-US',{style:'currency',currency:'USD'});

  function updateShipping(zone) {
    const copy = zone.querySelector('[data-mm-smart-shipping-copy]');
    if (!copy || zone.dataset.shippingReady) return;
    zone.dataset.shippingReady='true';
    fetch('/cart.js',{credentials:'same-origin',cache:'no-store'})
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(cart => {
        if (!Number.isSafeInteger(cart?.total_price) || cart.currency !== 'USD') return;
        const remaining=Math.max(0,10000-cart.total_price);
        const es=document.documentElement.lang?.startsWith('es');
        copy.textContent=remaining>0
          ? (es ? `Faltan ${money.format(remaining/100)} para el mínimo de $100.` : `Add ${money.format(remaining/100)} to reach the $100 threshold.`)
          : (es ? 'Ya alcanzaste el mínimo de $100; confirma al pagar.' : 'You reached the $100 threshold; confirm eligibility at checkout.');
      }).catch(()=>{});
  }

  function fill(root) {
    const top=root.querySelector('.r32-product-top');
    const media=top?.querySelector(':scope > .r32-product-media');
    const buy=top?.querySelector(':scope > .r32-product-buy');
    const zone=media?.querySelector('[data-mm-smart-fill]');
    if (!top || !media || !buy || !zone) return;
    const cards=[...zone.querySelectorAll('[data-mm-smart-fill-card]')]
      .sort((a,b)=>Number(a.dataset.priority)-Number(b.dataset.priority));
    zone.hidden=true;
    zone.removeAttribute('data-count');
    cards.forEach(card=>card.hidden=true);
    if (!desktop.matches) return;

    const tabs=media.querySelector(':scope > .r32-product-tabs');
    if (tabs && zone.previousElementSibling !== tabs) tabs.after(zone);

    const baseMediaHeight=media.getBoundingClientRect().height;
    const gap=Math.floor(buy.getBoundingClientRect().height-baseMediaHeight);
    if (gap < 145) return;

    let fitted=0;
    for (let count=Math.min(4,cards.length); count>=1; count--) {
      cards.forEach((card,index)=>card.hidden=index>=count);
      zone.dataset.count=String(count);
      zone.hidden=false;
      const required=Math.ceil(zone.getBoundingClientRect().height);
      if (required <= gap-8) { fitted=count; break; }
      zone.hidden=true;
    }
    if (!fitted) {
      cards.forEach(card=>card.hidden=true);
      zone.removeAttribute('data-count');
      return;
    }
    cards.forEach((card,index)=>card.hidden=index>=fitted);
    zone.dataset.count=String(fitted);
    zone.hidden=false;
    updateShipping(zone);
  }

  function init(scope=document) {
    const roots=[...(scope.matches?.('[data-mm-product-root]')?[scope]:[]),...scope.querySelectorAll?.('[data-mm-product-root]')||[]];
    roots.forEach(root=>{
      if(root.dataset.mmSmartFillReady) return;
      root.dataset.mmSmartFillReady='true';
      let pending=false;
      const run=()=>{
        if(pending || !root.isConnected) return;
        pending=true;
        requestAnimationFrame(()=>requestAnimationFrame(()=>{
          pending=false;
          if(root.isConnected) fill(root);
        }));
      };
      run();
      window.addEventListener('load',run,{once:true});
      desktop.addEventListener?.('change',run);
      window.addEventListener('resize',run,{passive:true});
      new ResizeObserver(run).observe(root.querySelector('.r32-product-buy')||root);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(),{once:true}); else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
